import React, { forwardRef, useEffect, useState, useMemo, useCallback } from 'react';
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import { find } from 'lodash';
import { FieldTypes } from 'utils/formUtils';
import message from "components/CustomMessage";
import GenericMappingForm from '../GenericMappingForm';

const GrammatechCodeSentryMappingForm = forwardRef(function GrammatechCodeSentryMappingForm(props, ref) {
    const [projects, setProjects] = useState(() => {
      if (props.record) {
        const { applicationId, applicationName } = props.record;
        return [{id: applicationId, name: applicationName}]
      }
      return [];
    });

    useEffect(() => {
      const { promise, cancel } = ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, { login_id: props.loginConfigId });
      promise.then((response) => {
        const { projects } = response;
        setProjects(projects);
      }).catch(() => {
        message.error('Problem fetching projects');
      });
  
      return cancel;
    }, [props.loginConfigId,props.toolName]);
  
    const getExtraFieldsData = useCallback((config) => {
      const { applicationId } = config;
      const applicationName = find(projects, (obj) => obj.id === applicationId)?.name;
  
      return ({
        applicationId,
        applicationName,
      });
    }, [projects])
  
    const extraFields = useMemo(() => ([
      {
        name: 'applicationId',
        colSpan: '12',
        type: FieldTypes.SELECT,
        label: 'Grammatech - CodeSentry Application',
        options: projects.map(option => {
          const { label = option.name, value = option.id } = option;
          return { label, value }
        }),
        rules: [{ required: true, message: `Grammatech - CodeSentry Application is required` }],
        props: {
          autoFocus: true
        }
      }
    ]), [projects]);
  return (
    <GenericMappingForm
      ref={ref}
      projects={projects}
      getExtraFieldsData={getExtraFieldsData}
      extraFields={extraFields}
      title="Map Grammatech - CodeSentry Application"
      {...props}
    />
  )
})

export default GrammatechCodeSentryMappingForm;
